(function () {
  var config = window.freeGiftConfig || {};
  var giftData = window.freeGiftData || {};

  var GATED_VARIANT_ID = Number(config.gatedVariantId || NaN);
  var GATED_PRODUCT_ID = Number(config.gatedProductId || NaN);
  var ENFORCED_GIFT_ID = Number(config.enforcedGiftId || 11691341873420);
  var GATED_HANDLE = config.gatedHandle || 'free-gift-teca-travel-kit';
  var GATED_GIFT_PROPERTY_VALUE = 'gated';
  var GATED_GIFT_RULE_VALUE = 'legacy_gift';

  function settingEnabled(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    if (value === false || value === 0) return false;

    var normalized = String(value).toLowerCase();
    if (normalized === 'false' || normalized === '0' || normalized === 'off' || normalized === 'no') return false;

    return true;
  }

  var MASK_THRESHOLD = Number(config.maskThresholdCents || 3000);
  var MASK_ENABLED = settingEnabled(config.maskEnabled, true);
  var MASK_VARIANT_ID = Number(config.maskVariantId || NaN);
  var MASK_GIFT_PROPERTY = '_free_gift';
  var MASK_GIFT_PROPERTY_VALUE = 'mask';
  var GIFT_RULE_PROPERTY = '_free_gift_rule';
  var MASK_GIFT_RULE_VALUES = ['cart_threshold_gift', '30_eur_mask'];

  var ALWAYS_VARIANT_ID = Number(config.alwaysVariantId || NaN);
  var ALWAYS_ENABLED = settingEnabled(config.alwaysEnabled, false);
  var ALWAYS_HANDLE = config.alwaysHandle || 'teca-lifting-moisture-cream';
  var ALWAYS_GIFT_PROPERTY_VALUE = 'always';
  var ALWAYS_GIFT_RULE_VALUE = 'always_gift';

  var syncInFlight = false;
  var syncQueued = false;
  var suppressNetworkHook = false;
  var lastBlockedState = null;
  var lastCartState = null;
  var scheduledSyncTimer = null;
  var scheduledSyncReason = '';
  var drawerPrevPositions = new Map();
  var viewCartLoadingActive = false;
  var optimisticRowClearTimer = null;
  var internalThemeRefreshActive = false;

  function getResolvedGatedVariantId() {
    var fromGiftData = Number(giftData && giftData.gated && giftData.gated.variantId);
    if (Number.isFinite(fromGiftData) && fromGiftData > 0) return fromGiftData;
    if (Number.isFinite(GATED_VARIANT_ID) && GATED_VARIANT_ID > 0) return GATED_VARIANT_ID;
    if (Number.isFinite(ENFORCED_GIFT_ID) && ENFORCED_GIFT_ID > 0) return ENFORCED_GIFT_ID;
    return NaN;
  }

  function getResolvedAlwaysVariantId() {
    var fromGiftData = Number(giftData && giftData.always && giftData.always.variantId);
    if (Number.isFinite(fromGiftData) && fromGiftData > 0) return fromGiftData;
    if (Number.isFinite(ALWAYS_VARIANT_ID) && ALWAYS_VARIANT_ID > 0) return ALWAYS_VARIANT_ID;
    return NaN;
  }

  function getResolvedMaskVariantId() {
    var fromGiftData = Number(giftData && giftData.mask && giftData.mask.variantId);
    if (Number.isFinite(fromGiftData) && fromGiftData > 0) return fromGiftData;
    if (Number.isFinite(MASK_VARIANT_ID) && MASK_VARIANT_ID > 0) return MASK_VARIANT_ID;
    return NaN;
  }

  function buildIdSet(values) {
    var set = new Set();
    values.forEach(function (value) {
      var parsed = Number(value);
      if (Number.isFinite(parsed) && parsed > 0) set.add(parsed);
    });
    return set;
  }

  function getGatedVariantIdSet() {
    return buildIdSet([
      getResolvedGatedVariantId(),
      GATED_VARIANT_ID,
      ENFORCED_GIFT_ID
    ]);
  }

  function getGatedProductIdSet() {
    var fromGiftData = Number(giftData && giftData.gated && giftData.gated.id);
    return buildIdSet([
      GATED_PRODUCT_ID,
      fromGiftData,
      ENFORCED_GIFT_ID
    ]);
  }

  function isGatedGiftItem(item) {
    if (!item) return false;

    var variantId = Number(item.variant_id);
    var productId = Number(item.product_id);
    var itemHandle = String(item.handle || '').toLowerCase();
    var matchesGatedGift = getGatedVariantIdSet().has(variantId) ||
      getGatedProductIdSet().has(productId) ||
      (itemHandle && itemHandle === String(GATED_HANDLE || '').toLowerCase());

    if (!matchesGatedGift) return false;
    if (getLineProperty(item, MASK_GIFT_PROPERTY) === GATED_GIFT_PROPERTY_VALUE) return true;
    if (getLineProperty(item, GIFT_RULE_PROPERTY) === GATED_GIFT_RULE_VALUE) return true;

    return false;
  }

  function safeMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}}');
      }
    } catch (error) {}

    return 'EUR ' + (Number(cents || 0) / 100).toFixed(2);
  }

  function getGiftVariantIds() {
    return [getResolvedGatedVariantId()].filter(function (id) {
      return Number.isFinite(id) && id > 0;
    });
  }

  function getMaskVariantIdSet() {
    return buildIdSet([
      getResolvedMaskVariantId(),
      MASK_VARIANT_ID
    ]);
  }

  function isMaskGiftItem(item) {
    if (!item) return false;

    var variantId = Number(item.variant_id);
    if (!getMaskVariantIdSet().has(variantId)) return false;

    return getLineProperty(item, MASK_GIFT_PROPERTY) === MASK_GIFT_PROPERTY_VALUE &&
      MASK_GIFT_RULE_VALUES.indexOf(getLineProperty(item, GIFT_RULE_PROPERTY)) !== -1;
  }

  function isZeroPriceItem(item) {
    if (!item) return false;

    return Number(item.final_line_price) === 0 ||
      Number(item.line_price) === 0 ||
      Number(item.final_price) === 0 ||
      Number(item.price) === 0;
  }

  function getLineProperty(item, name) {
    var properties = item && item.properties;
    if (!properties || !name) return '';

    if (Array.isArray(properties)) {
      for (var i = 0; i < properties.length; i += 1) {
        var property = properties[i];
        if (Array.isArray(property) && property[0] === name) return String(property[1] || '');
        if (property && property.name === name) return String(property.value || '');
      }
      return '';
    }

    return String(properties[name] || '');
  }

  function getAlwaysVariantIdSet() {
    return buildIdSet([
      getResolvedAlwaysVariantId(),
      ALWAYS_VARIANT_ID
    ]);
  }

  function isAlwaysGiftItem(item) {
    if (!item) return false;

    var variantId = Number(item.variant_id);
    var itemHandle = String(item.handle || '').toLowerCase();
    var matchesAlwaysGift = getAlwaysVariantIdSet().has(variantId) ||
      (itemHandle && itemHandle === String(ALWAYS_HANDLE || '').toLowerCase());

    if (!matchesAlwaysGift) return false;
    if (getLineProperty(item, MASK_GIFT_PROPERTY) === ALWAYS_GIFT_PROPERTY_VALUE) return true;
    if (getLineProperty(item, GIFT_RULE_PROPERTY) === ALWAYS_GIFT_RULE_VALUE) return true;

    return false;
  }

  function isExternalFreeGiftItem(item) {
    if (!item || !isZeroPriceItem(item)) return false;
    if (isGatedGiftItem(item) || isMaskGiftItem(item) || isAlwaysGiftItem(item)) return false;
    return true;
  }

  function getCartPageList() {
    var cartRoot = document.getElementById('main-cart-items');
    return cartRoot ? cartRoot.querySelector('.cart-list') : null;
  }

  function getDrawerList() {
    return document.querySelector('#halo-cart-sidebar .previewCartList');
  }

  function getCartProgressRoot() {
    return document.getElementById('main-cart-items');
  }

  function getDrawerProgressRoot() {
    return document.getElementById('cart-sidebar-sticky-header') ||
      document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper') ||
      document.querySelector('#halo-cart-sidebar');
  }

  function setProgressBlock(container, id, html) {
    if (!container) return;

    var node = container.querySelector('#' + id);

    if (!html) {
      if (node) node.remove();
      return;
    }

    if (!node) {
      node = document.createElement('div');
      node.id = id;
      node.className = 'freegift-progress';

      if (container.id === 'main-cart-items') {
        var cartList = getCartPageList();
        if (cartList) container.insertBefore(node, cartList);
        else container.prepend(node);
      } else {
        container.prepend(node);
      }
    }

    node.innerHTML = html;
  }

  function orderProgressBlocks(container, ids) {
    if (!container) return;

    var beforeNode = container.id === 'main-cart-items' ? getCartPageList() : container.firstChild;
    ids.slice().reverse().forEach(function (id) {
      var node = container.querySelector('#' + id);
      if (!node) return;
      container.insertBefore(node, beforeNode);
      beforeNode = node;
    });
  }

  function orderAllProgressBlocks() {
    orderProgressBlocks(getDrawerProgressRoot(), [
      'free-gift-surprise-drawer',
      'free-mask-progress-drawer'
    ]);
    orderProgressBlocks(getCartProgressRoot(), [
      'free-gift-surprise-cart',
      'free-mask-progress-cart'
    ]);
  }

  var lastSurpriseUnlockedAt = 0;
  var SURPRISE_CONFIRM_MS = 1800;
  var lastMaskUnlockedAt = 0;
  var lastMaskAddedAt = 0;
  var MASK_CONFIRM_MS = 2200;
  var prevPaidQty = 0;
  var prevHasMaskGift = false;
  var prevShouldHaveMaskGift = false;

  function renderProgress(cartState) {
    var paidLines = cartState.paidLineCount;
    var paidQty = cartState.paidQuantityTotal || 0;
    var hasMaskGift = cartState.hasMaskGift;
    var maskRemaining = Math.max(0, MASK_THRESHOLD - cartState.paidSubtotal);
    var maskHtml = '';
    var surpriseHtml = '';

    // Detect transition: just crossed from < 2 → >= 2
    if (ALWAYS_ENABLED && prevPaidQty < 2 && paidQty >= 2) {
      lastSurpriseUnlockedAt = Date.now();
    }
    prevPaidQty = paidQty;

    if (!prevShouldHaveMaskGift && cartState.shouldHaveMaskGift) {
      lastMaskUnlockedAt = Date.now();
    }

    if (!prevHasMaskGift && hasMaskGift && cartState.shouldHaveMaskGift && lastMaskUnlockedAt > 0) {
      lastMaskAddedAt = Date.now();
    } else if (!cartState.shouldHaveMaskGift) {
      lastMaskUnlockedAt = 0;
      lastMaskAddedAt = 0;
    }

    prevHasMaskGift = hasMaskGift;
    prevShouldHaveMaskGift = cartState.shouldHaveMaskGift;

    var stillConfirming = (Date.now() - lastSurpriseUnlockedAt) < SURPRISE_CONFIRM_MS;
    var maskStillAdding = cartState.shouldHaveMaskGift && !hasMaskGift;
    var maskStillConfirming = hasMaskGift && lastMaskAddedAt > 0 && (Date.now() - lastMaskAddedAt) < MASK_CONFIRM_MS;

    if (ALWAYS_ENABLED && paidQty > 0 && paidQty < 2) {
      surpriseHtml = '<div class="freegift-surprise__bar freegift-surprise__bar--pending"><span class="freegift-surprise__icon"></span> <strong>Add 1 more product</strong> to get a surprise gift from us!</div>';
    } else if (ALWAYS_ENABLED && paidQty >= 2 && stillConfirming) {
      // Briefly show "Surprise gift added!" before transitioning to the regular progress bar
      surpriseHtml = '<div class="freegift-surprise__bar freegift-surprise__bar--added"><span class="freegift-surprise__icon"></span> <strong>Surprise gift added!</strong></div>';
      // Schedule a re-render once the confirmation window ends
      setTimeout(function () {
        if (lastCartState) renderProgress(lastCartState);
      }, SURPRISE_CONFIRM_MS - (Date.now() - lastSurpriseUnlockedAt) + 50);
    }

    if (MASK_ENABLED && paidLines > 0) {
      if (maskRemaining > 0) {
        maskHtml = '<div class="freegift-progress__bar freegift-progress__bar--pending freegift-progress__bar--mask freegift-progress__bar--enter"><strong>You\'re ' +
          safeMoney(maskRemaining) +
          ' away</strong> from your free gift</div>';
      } else if (maskStillAdding) {
        maskHtml = '<div class="freegift-progress__bar freegift-progress__bar--unlocked freegift-progress__bar--mask freegift-progress__bar--enter">You unlocked your <strong>free gift</strong>. Adding it now...</div>';
      } else if (maskStillConfirming) {
        maskHtml = '<div class="freegift-progress__bar freegift-progress__bar--added freegift-progress__bar--mask freegift-progress__bar--enter"><strong>Free gift added!</strong></div>';
        setTimeout(function () {
          if (lastCartState) renderProgress(lastCartState);
        }, MASK_CONFIRM_MS - (Date.now() - lastMaskAddedAt) + 50);
      }
    }

    setProgressBlock(getDrawerProgressRoot(), 'free-gift-progress-drawer', '');
    setProgressBlock(getCartProgressRoot(), 'free-gift-progress-cart', '');
    setProgressBlock(getDrawerProgressRoot(), 'free-mask-progress-drawer', maskHtml);
    setProgressBlock(getCartProgressRoot(), 'free-mask-progress-cart', maskHtml);
    setProgressBlock(getDrawerProgressRoot(), 'free-gift-surprise-drawer', surpriseHtml);
    setProgressBlock(getCartProgressRoot(), 'free-gift-surprise-cart', surpriseHtml);
    orderAllProgressBlocks();
  }

  function buildDrawerStaticRow(type, data) {
    if (!data) return '';

    return '' +
      '<li class="previewCartItem clearfix gift-static gift-static--drawer s-' + data.variantId + '" data-static-gift="' + type + '" data-static-gift-variant="' + Number(data.variantId || 0) + '">' +
        '<div class="previewCartItem-image" role="img" aria-label="' + escapeHtml(data.title) + '">' +
          '<img src="' + data.image + '" width="110" alt="' + escapeHtml(data.title) + '" loading="lazy">' +
        '</div>' +
        '<div class="previewCartItem-content cart-item-block-right">' +
          '<div class="previewCartItem-top-row">' +
            '<div class="previewCartItem-top-row__title">' +
              '<span class="previewCartItem-name card-title"><span class="text">' + escapeHtml(data.title) + '</span></span>' +
              '<span class="gift-label">FREE GIFT</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>';
  }

  function buildCartStaticRow(type, data) {
    if (!data) return '';

    return '' +
      '<div class="cart-item cart-item--static-gift gift-static gift-static--cart s-' + data.variantId + '" data-static-gift="' + type + '" data-static-gift-variant="' + Number(data.variantId || 0) + '">' +
        '<div class="cart-item-block cart-item-info">' +
          '<div class="cart-item-wrapper">' +
            '<div class="cart-item-block-left">' +
              '<div class="cart-item-image image-adapt" role="img" aria-label="' + escapeHtml(data.title) + '" style="padding-bottom: 100%">' +
                '<img src="' + data.image + '" srcset="' + data.image + '" alt="' + escapeHtml(data.title) + '" sizes="160px" loading="lazy" width="110" height="110">' +
              '</div>' +
            '</div>' +
            '<div class="cart-item-block-right">' +
              '<h4 class="cart-item-name">' +
                '<span class="link"><span class="text">' + escapeHtml(data.title) + '</span></span>' +
              '</h4>' +
              '<div class="cart-static-gift-meta">' +
                '<span class="gift-label">FREE GIFT</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="cart-item-block cart-item-price"></div>' +
        '<div class="cart-item-block cart-item-quantity"></div>' +
        '<div class="cart-item-block cart-item-total"></div>' +
      '</div>';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function ensureStaticRow(list, type, data, shouldShow) {
    if (!list) return;

    var selector = '[data-static-gift="' + type + '"]';
    var allExisting = list.querySelectorAll(selector);
    var existing = allExisting.length ? allExisting[0] : null;
    var nextVariantId = Number(data && data.variantId || 0);
    var nextTitle = String(data && data.title || '');
    var nextImage = normalizeImageUrl(data && data.image || '');

    if (allExisting.length > 1) {
      for (var i = 1; i < allExisting.length; i += 1) {
        allExisting[i].remove();
      }
    }

    if (!shouldShow || !data) {
      if (existing) existing.remove();
      return;
    }

    if (existing) {
      var existingVariantId = Number(existing.getAttribute('data-static-gift-variant') || 0);
      var existingTitle = String(existing.getAttribute('data-static-gift-title') || '');
      var existingImage = String(existing.getAttribute('data-static-gift-image') || '');
      var isMalformed = !existing.querySelector('img') ||
        !existing.querySelector('.previewCartItem-name .text, .cart-item-name .text') ||
        !existing.querySelector('.gift-label');

      if (isMalformed || existingVariantId !== nextVariantId || existingTitle !== nextTitle || existingImage !== nextImage) {
        existing.remove();
        existing = null;
      }
    }

    if (!existing) {
      var html = list.classList.contains('previewCartList')
        ? buildDrawerStaticRow(type, data)
        : buildCartStaticRow(type, data);
      list.insertAdjacentHTML('afterbegin', html);
      existing = list.querySelector('[data-static-gift="' + type + '"]');
    }

    if (existing) {
      existing.setAttribute('data-static-gift-variant', String(nextVariantId));
      existing.setAttribute('data-static-gift-title', nextTitle);
      existing.setAttribute('data-static-gift-image', nextImage);

      var image = existing.querySelector('img');
      if (image && nextImage && image.getAttribute('src') !== nextImage) {
        image.setAttribute('src', nextImage);
        image.setAttribute('srcset', nextImage);
      }
      if (image && nextTitle) {
        image.setAttribute('alt', nextTitle);
      }

      var title = existing.querySelector('.previewCartItem-name .text, .cart-item-name .text');
      if (title && nextTitle && title.textContent !== nextTitle) {
        title.textContent = nextTitle;
      }
    }

    if (existing && list.firstElementChild !== existing) {
      list.insertBefore(existing, list.firstElementChild);
    }
  }

  function dedupeStaticRows(list) {
    if (!list) return;

    var seenTypes = new Set();
    list.querySelectorAll('[data-static-gift]').forEach(function (node) {
      var type = node.getAttribute('data-static-gift') || '';
      if (seenTypes.has(type)) {
        node.remove();
      } else {
        seenTypes.add(type);
      }
    });
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    var raw = String(url);
    if (raw.indexOf('//') === 0) return 'https:' + raw;
    return raw;
  }

  function buildFallbackGiftData(type, cartState) {
    var source = type === 'gated' ? cartState.gatedLine : (type === 'mask' ? cartState.maskLine : cartState.alwaysLine);
    var sourceImage = '';

    if (source) {
      sourceImage = source.image ||
        (source.featured_image && source.featured_image.url) ||
        '';
    }

    var fallback = {
      variantId: type === 'gated' ? getResolvedGatedVariantId() : (type === 'mask' ? getResolvedMaskVariantId() : getResolvedAlwaysVariantId()),
      title: type === 'gated' ? 'FREE GIFT - Teca Travel Kit' : (type === 'mask' ? 'Free Gift' : 'TECA Lifting Moisture Cream Sample (2ml)'),
      image: normalizeImageUrl(sourceImage),
      url: type === 'gated' ? '/products/' + GATED_HANDLE : (type === 'mask' ? '' : '/products/' + ALWAYS_HANDLE)
    };

    if (source) {
      if (source.variant_id) fallback.variantId = Number(source.variant_id);
      if (source.product_title) fallback.title = String(source.product_title);
    }

    if (!Number.isFinite(fallback.variantId) || fallback.variantId <= 0) {
      fallback.variantId = type === 'gated' ? ENFORCED_GIFT_ID : (type === 'mask' ? getResolvedMaskVariantId() : getResolvedAlwaysVariantId());
    }

    return fallback;
  }

  function resolveGiftData(type, cartState) {
    var base = type === 'gated' ? (giftData && giftData.gated) : (type === 'mask' ? (giftData && giftData.mask) : (giftData && giftData.always));
    var fallback = buildFallbackGiftData(type, cartState);
    var preferFallback = type === 'mask' && cartState && cartState.maskLine;
    var resolved = {
      variantId: Number((preferFallback ? fallback.variantId : (base && base.variantId)) || fallback.variantId || 0),
      title: String((preferFallback ? fallback.title : (base && base.title)) || fallback.title || ''),
      image: normalizeImageUrl((preferFallback ? fallback.image : (base && base.image)) || fallback.image || ''),
      url: String((preferFallback ? fallback.url : (base && base.url)) || fallback.url || '')
    };

    if (!resolved.title) resolved.title = fallback.title;
    if (!resolved.url) resolved.url = fallback.url;
    if (!resolved.image) resolved.image = 'https://cdn.shopify.com/s/files/1/0684/6555/7772/files/og.png';

    if (!Number.isFinite(resolved.variantId) || resolved.variantId <= 0) {
      resolved.variantId = Number(fallback.variantId || 0);
    }

    return resolved;
  }

  function syncStaticRows(cartState) {
    var drawerList = getDrawerList();
    var cartList = getCartPageList();
    var shouldShowMask = cartState.hasMaskGift || cartState.shouldHaveMaskGift;
    var shouldShowAlways = cartState.hasAlwaysGift || cartState.shouldHaveAlwaysGift;
    var maskGiftData = resolveGiftData('mask', cartState);
    var alwaysGiftData = resolveGiftData('always', cartState);

    ensureStaticRow(drawerList, 'gated', null, false);
    ensureStaticRow(cartList, 'gated', null, false);

    ensureStaticRow(drawerList, 'mask', maskGiftData, shouldShowMask);
    ensureStaticRow(cartList, 'mask', maskGiftData, shouldShowMask);

    ensureStaticRow(drawerList, 'always', alwaysGiftData, shouldShowAlways);
    ensureStaticRow(cartList, 'always', alwaysGiftData, shouldShowAlways);

    ['mask', 'always'].forEach(function (type) {
      [drawerList, cartList].forEach(function (list) {
        if (!list) return;
        var node = list.querySelector('[data-static-gift="' + type + '"]');
        if (node && list.firstElementChild !== node) {
          list.insertBefore(node, list.firstElementChild);
        }
      });
    });

    dedupeStaticRows(drawerList);
    dedupeStaticRows(cartList);
  }

  function rowMatchesGift(row) {
    if (!row || row.dataset.staticGift) return false;

    var href = '';
    var anchor = row.querySelector('a[href*="/products/"]');
    if (anchor) href = anchor.getAttribute('href') || '';
    return row.getAttribute('data-auto-free-gift') === 'gated' ||
      row.getAttribute('data-auto-free-gift') === 'mask' ||
      row.getAttribute('data-auto-free-gift') === 'always';
  }

  function hideRealGiftRows() {
    document.querySelectorAll('.previewCartItem, .cart-item, [data-item-row]').forEach(function (row) {
      if (!rowMatchesGift(row)) return;
      row.classList.add('gift-row-hidden');
      row.style.display = 'none';
    });
  }

  function setCheckoutBlocked(blocked) {
    if (lastBlockedState === blocked) return;
    lastBlockedState = blocked;

    var buttons = document.querySelectorAll('.button-checkout, [name="checkout"], #cart-checkout, #cart-sidebar-checkout');

    buttons.forEach(function (button) {
      if (blocked) {
        button.dataset.fgBlocked = 'true';
        button.setAttribute('aria-disabled', 'true');
        if (button.tagName === 'BUTTON') {
          button.dataset.fgDisabledByScript = button.disabled ? 'true' : 'false';
          button.disabled = true;
        }
      } else {
        delete button.dataset.fgBlocked;
        button.removeAttribute('aria-disabled');

        if (button.tagName === 'BUTTON' && button.dataset.fgDisabledByScript === 'false') {
          button.disabled = false;
        }

        delete button.dataset.fgDisabledByScript;
      }
    });
  }

  function getCartState(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var giftVariantIds = getGiftVariantIds();
    var paidSubtotal = 0;
    var paidLineCount = 0;
    var paidQuantityTotal = 0;
    var hasGatedGift = false;
    var hasMaskGift = false;
    var hasAlwaysGift = false;
    var hasExternalMaskGift = false;
    var hasExternalAlwaysGift = false;
    var gatedLine = null;
    var maskLine = null;
    var alwaysLine = null;

    items.forEach(function (item) {
      var variantId = Number(item.variant_id);
      var itemHandle = String(item.handle || '').toLowerCase();
      var isGatedGift = isGatedGiftItem(item);
      var isMaskGift = isMaskGiftItem(item);
      var isAlwaysGift = isAlwaysGiftItem(item);
      var isExternalMaskGift = !isMaskGift && getMaskVariantIdSet().has(variantId) && isZeroPriceItem(item);
      var isExternalAlwaysGift = !isAlwaysGift &&
        (getAlwaysVariantIdSet().has(variantId) || (itemHandle && itemHandle === String(ALWAYS_HANDLE || '').toLowerCase())) &&
        isZeroPriceItem(item);
      var isExternalFreeGift = isExternalFreeGiftItem(item);
      var isGift = isGatedGift || isMaskGift || isAlwaysGift || isExternalMaskGift || isExternalAlwaysGift || isExternalFreeGift || giftVariantIds.indexOf(variantId) !== -1;

      if (isGatedGift) {
        hasGatedGift = true;
        gatedLine = item;
      }

      if (isMaskGift) {
        hasMaskGift = true;
        maskLine = item;
      }

      if (isAlwaysGift) {
        hasAlwaysGift = true;
        alwaysLine = item;
      }

      if (isExternalMaskGift) {
        hasExternalMaskGift = true;
      }

      if (isExternalAlwaysGift) {
        hasExternalAlwaysGift = true;
      }

      if (isGift) return;

      var qty = Number(item.quantity) || 0;
      if (qty > 0) {
        paidLineCount += 1;
        paidQuantityTotal += qty;
      }

      if (typeof item.final_line_price === 'number') {
        paidSubtotal += item.final_line_price;
      } else if (typeof item.line_price === 'number') {
        paidSubtotal += item.line_price;
      } else {
        paidSubtotal += Number(item.final_price || item.price || 0) * Number(item.quantity || 1);
      }
    });

    return {
      cart: cart,
      items: items,
      paidSubtotal: paidSubtotal,
      paidLineCount: paidLineCount,
      paidQuantityTotal: paidQuantityTotal,
      hasGatedGift: hasGatedGift,
      hasMaskGift: hasMaskGift,
      hasAlwaysGift: hasAlwaysGift,
      hasExternalMaskGift: hasExternalMaskGift,
      hasExternalAlwaysGift: hasExternalAlwaysGift,
      gatedLine: gatedLine,
      maskLine: maskLine,
      alwaysLine: alwaysLine,
      shouldHaveGatedGift: false,
      shouldHaveMaskGift: MASK_ENABLED && paidLineCount > 0 && paidSubtotal >= MASK_THRESHOLD,
      shouldHaveAlwaysGift: ALWAYS_ENABLED && Number.isFinite(getResolvedAlwaysVariantId()) && getResolvedAlwaysVariantId() > 0 && paidQuantityTotal >= 2
    };
  }

  function applyVisualState(cartState) {
    if (!cartState) return;
    renderProgress(cartState);
    syncStaticRows(cartState);
    hideRealGiftRows();
    setCheckoutBlocked(cartState.items.length > 0 && cartState.paidLineCount === 0);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (response) {
      return response.json();
    });
  }

  function postCart(url, body) {
    window.__bgcCartRequestCount = Math.max(0, Number(window.__bgcCartRequestCount || 0) + 1);
    document.dispatchEvent(new CustomEvent('cart:request:state', {
      detail: { active: true, count: window.__bgcCartRequestCount, source: 'freegift' }
    }));
    suppressNetworkHook = true;

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (response.ok) return response;
      return response.text().then(function (text) {
        throw new Error('Cart request failed: ' + url + ' ' + response.status + ' ' + text);
      });
    }).finally(function () {
      suppressNetworkHook = false;
      window.__bgcCartRequestCount = Math.max(0, Number(window.__bgcCartRequestCount || 0) - 1);
      document.dispatchEvent(new CustomEvent('cart:request:state', {
        detail: { active: window.__bgcCartRequestCount > 0, count: window.__bgcCartRequestCount, source: 'freegift' }
      }));
    });
  }

  function buildMutationQueue(cartState) {
    var queue = [];

    if (cartState.hasGatedGift && cartState.gatedLine) {
      queue.push(function () {
        return postCart('/cart/change.js', { id: cartState.gatedLine.key, quantity: 0 });
      });
    }

    var resolvedMaskVariantId = getResolvedMaskVariantId();

    if (Number.isFinite(resolvedMaskVariantId) && resolvedMaskVariantId > 0) {
      if (cartState.hasMaskGift && !cartState.shouldHaveMaskGift && cartState.maskLine) {
        queue.push(function () {
          return postCart('/cart/change.js', { id: cartState.maskLine.key, quantity: 0 });
        });
      }

      if (!cartState.hasMaskGift && !cartState.hasExternalMaskGift && cartState.shouldHaveMaskGift) {
        queue.push(function () {
          var properties = {};
          properties[MASK_GIFT_PROPERTY] = MASK_GIFT_PROPERTY_VALUE;
          properties[GIFT_RULE_PROPERTY] = 'cart_threshold_gift';
          return postCart('/cart/add.js', { id: resolvedMaskVariantId, quantity: 1, properties: properties });
        });
      }
    }

    var resolvedAlwaysVariantId = getResolvedAlwaysVariantId();

    if (Number.isFinite(resolvedAlwaysVariantId) && resolvedAlwaysVariantId > 0) {
      if (cartState.hasAlwaysGift && !cartState.shouldHaveAlwaysGift && cartState.alwaysLine) {
        queue.push(function () {
          return postCart('/cart/change.js', { id: cartState.alwaysLine.key, quantity: 0 });
        });
      }

      if (!cartState.hasAlwaysGift && !cartState.hasExternalAlwaysGift && cartState.shouldHaveAlwaysGift) {
        queue.push(function () {
          var properties = {};
          properties[MASK_GIFT_PROPERTY] = ALWAYS_GIFT_PROPERTY_VALUE;
          properties[GIFT_RULE_PROPERTY] = ALWAYS_GIFT_RULE_VALUE;
          return postCart('/cart/add.js', { id: resolvedAlwaysVariantId, quantity: 1, properties: properties });
        });
      }
    }

    return queue;
  }

  function runMutationQueue(queue) {
    return queue.reduce(function (promise, task) {
      return promise.then(task);
    }, Promise.resolve());
  }

  function refreshThemeUi(cart) {
    internalThemeRefreshActive = true;

    if (window.halo && typeof window.halo.updateCart === 'function' && document.getElementById('main-cart-items')) {
      window.halo.updateCart(cart);
    }

    if (window.halo && typeof window.halo.updateSidebarCart === 'function' && document.querySelector('#halo-cart-sidebar .previewCart-wrapper')) {
      window.halo.updateSidebarCart(cart);
    }

    setTimeout(function () {
      internalThemeRefreshActive = false;
    }, 1400);
  }

  function scheduleSync(reason, delayMs) {
    if (typeof delayMs !== 'number') delayMs = 60;
    scheduledSyncReason = reason || 'scheduled';

    if (scheduledSyncTimer) {
      clearTimeout(scheduledSyncTimer);
    }

    scheduledSyncTimer = setTimeout(function () {
      scheduledSyncTimer = null;
      queueSync(scheduledSyncReason);
    }, Math.max(0, delayMs));
  }

  function getDrawerItemSignature(node) {
    if (!node) return '';
    var title = (node.querySelector('.previewCartItem-name .text') || node.querySelector('.previewCartItem-name') || {}).textContent || '';
    var variant = (node.querySelector('.previewCartItem-variant') || {}).textContent || '';
    var image = (node.querySelector('.previewCartItem-image img') || {}).getAttribute ? (node.querySelector('.previewCartItem-image img').getAttribute('src') || '') : '';
    return [title.trim(), variant.trim(), image.trim()].join('||');
  }

  function animateDrawerTransition() {
    var list = getDrawerList();
    if (!list) return;

    var items = Array.prototype.slice.call(
      list.querySelectorAll('.previewCartItem:not(.gift-static):not(.gift-row-hidden)')
    );
    if (!items.length) {
      drawerPrevPositions = new Map();
      return;
    }

    var nextPositions = new Map();

    items.forEach(function (item) {
      var signature = getDrawerItemSignature(item);
      if (!signature) return;
      nextPositions.set(signature, item.getBoundingClientRect().top);
    });

    items.forEach(function (item) {
      var signature = getDrawerItemSignature(item);
      if (!signature) return;

      var oldTop = drawerPrevPositions.get(signature);
      var newTop = nextPositions.get(signature);

      // FLIP reposition animation disabled — only new-item fade-slide is used
    });

    var topItem = items[0];
    if (topItem) {
      var topSignature = getDrawerItemSignature(topItem);
      if (topSignature && !drawerPrevPositions.has(topSignature)) {
        topItem.classList.remove('cart-item-enter-right');
        void topItem.offsetWidth;
        topItem.classList.add('cart-item-enter-right');
        setTimeout(function () {
          topItem.classList.remove('cart-item-enter-right');
        }, 520);
      }
    }

    drawerPrevPositions = nextPositions;
  }

  function queueSync(reason) {
    if (syncInFlight) {
      syncQueued = true;
      return;
    }

    syncInFlight = true;

    fetchCart()
      .then(function (cart) {
        var cartState = getCartState(cart);
        var queue = buildMutationQueue(cartState);
        lastCartState = cartState;

        applyVisualState(cartState);

        if (!queue.length) {
          return cart;
        }

        return runMutationQueue(queue)
          .then(fetchCart)
          .then(function (updatedCart) {
            var updatedState = getCartState(updatedCart);
            lastCartState = updatedState;
            refreshThemeUi(updatedCart);
            applyVisualState(updatedState);
            setTimeout(function () { applyVisualState(updatedState); }, 150);
            return updatedCart;
          });
      })
      .catch(function (error) {
        console.error('Free gift sync failed' + (reason ? ' during ' + reason : ''), error);
      })
      .finally(function () {
        syncInFlight = false;

        if (syncQueued) {
          syncQueued = false;
          queueSync('queued');
        }
      });
  }

  function shouldReactToUrl(url, method) {
    return !!url && (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      (String(method || 'GET').toUpperCase() === 'POST' && /\/cart(\/|$|\?)/.test(url))
    );
  }

  function bindCartMutationHooks() {
    var nativeFetch = window.fetch;

    window.fetch = function (resource, init) {
      var promise = nativeFetch.apply(this, arguments);
      var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      var method = init && init.method ? init.method : 'GET';

      if (!suppressNetworkHook && shouldReactToUrl(url, method)) {
        promise.then(function () {
          queueMicrotask(function () { scheduleSync('fetch', 180); });
        }).catch(function () {});
      }

      return promise;
    };

    if (window.jQuery) {
      window.jQuery(document).ajaxComplete(function (_event, _xhr, settings) {
        if (!settings || suppressNetworkHook) return;
        if (shouldReactToUrl(settings.url || '', settings.type || 'GET')) {
          queueMicrotask(function () { scheduleSync('jquery', 180); });
        }
      });
    }

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._freeGiftMethod = method;
      this._freeGiftUrl = url;
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      this.addEventListener('load', function () {
        if (suppressNetworkHook) return;

        if (shouldReactToUrl(this.responseURL || this._freeGiftUrl || '', this._freeGiftMethod || 'GET')) {
          queueMicrotask(function () { scheduleSync('xhr', 180); });
        }
      });

      return nativeSend.apply(this, arguments);
    };
  }

  function bindThemeHooks() {
    function getLineFromControl(control) {
      if (!control) return '';

      var line = control.getAttribute && control.getAttribute('data-line');
      if (line) return String(line);

      var withLine = control.closest && control.closest('[data-line]');
      if (withLine) {
        var nestedLine = withLine.getAttribute('data-line');
        if (nestedLine) return String(nestedLine);
      }

      return '';
    }

    function getRowsByLine(line) {
      if (!line) return [];
      var matches = [];
      document.querySelectorAll('[data-item-row][data-line]').forEach(function (row) {
        if (!row || row.dataset.staticGift) return;
        if (String(row.getAttribute('data-line') || '') === String(line)) {
          matches.push(row);
        }
      });
      return matches;
    }

    function setGlobalPendingState(active) {
      document.body.classList.toggle('cart-action-pending', !!active);
    }

    function clearOptimisticRows() {
      document.querySelectorAll('.cart-row-optimistic').forEach(function (row) {
        row.classList.remove(
          'cart-row-optimistic',
          'cart-row-removing'
        );
        row.removeAttribute('aria-busy');
        lockRowInteractions(row, false);
      });
      setGlobalPendingState(false);
    }

    function lockRowInteractions(row, shouldLock) {
      if (!row) return;

      var controls = row.querySelectorAll('[data-cart-quantity], .btn-quantity, [data-cart-remove], .cart-remove, .previewCartItem-remove');

      controls.forEach(function (control) {
        if (!control) return;

        if (shouldLock) {
          if (control.dataset.fgRowLocked === '1') return;
          control.dataset.fgRowLocked = '1';

          if (typeof control.disabled !== 'undefined') {
            control.dataset.fgPrevDisabled = control.disabled ? '1' : '0';
            control.disabled = true;
          }

          if (control.tagName === 'INPUT') {
            control.dataset.fgPrevReadonly = control.readOnly ? '1' : '0';
            control.readOnly = true;
          }

          if (control.tagName === 'A') {
            control.dataset.fgPrevTabindex = control.hasAttribute('tabindex')
              ? String(control.getAttribute('tabindex'))
              : '';
            control.setAttribute('tabindex', '-1');
          }

          control.setAttribute('aria-disabled', 'true');
          return;
        }

        if (control.dataset.fgRowLocked !== '1') return;
        delete control.dataset.fgRowLocked;

        if (typeof control.disabled !== 'undefined') {
          var prevDisabled = control.dataset.fgPrevDisabled === '1';
          control.disabled = prevDisabled;
          delete control.dataset.fgPrevDisabled;
        }

        if (control.tagName === 'INPUT') {
          var prevReadonly = control.dataset.fgPrevReadonly === '1';
          control.readOnly = prevReadonly;
          delete control.dataset.fgPrevReadonly;
        }

        if (control.tagName === 'A') {
          var prevTabindex = control.dataset.fgPrevTabindex;
          if (prevTabindex === '') control.removeAttribute('tabindex');
          else control.setAttribute('tabindex', prevTabindex);
          delete control.dataset.fgPrevTabindex;
        }

        control.removeAttribute('aria-disabled');
      });
    }

    function scheduleOptimisticRowClear(delayMs) {
      if (optimisticRowClearTimer) {
        clearTimeout(optimisticRowClearTimer);
      }

      optimisticRowClearTimer = setTimeout(function () {
        optimisticRowClearTimer = null;
        clearOptimisticRows();
      }, typeof delayMs === 'number' ? delayMs : 0);
    }

    function setOptimisticRowState(control, type, nextQuantity) {
      var line = getLineFromControl(control);
      if (!line) return;

      getRowsByLine(line).forEach(function (row) {
        row.classList.add('cart-row-optimistic');
        row.classList.toggle('cart-row-removing', type === 'remove');
        row.setAttribute('aria-busy', 'true');
        lockRowInteractions(row, true);

        if (Number.isFinite(nextQuantity) && nextQuantity >= 0) {
          row.querySelectorAll('[data-cart-quantity]').forEach(function (qtyInput) {
            qtyInput.value = String(nextQuantity);
          });
        }
      });
    }

    function setViewCartButtonLoading(active) {
      if (viewCartLoadingActive === active) return;
      viewCartLoadingActive = active;

      document.querySelectorAll('#halo-cart-sidebar .button-view-cart').forEach(function (button) {
        if (!button.dataset.defaultLabel) {
          button.dataset.defaultLabel = button.textContent.trim();
        }

        button.classList.toggle('is-cart-loading', active);
        button.setAttribute('aria-busy', active ? 'true' : 'false');
        button.textContent = active ? 'Loading...' : (button.dataset.defaultLabel || 'View cart');
      });
    }

    document.addEventListener('cart:request:state', function (event) {
      var isActive = !!(event && event.detail && event.detail.active);
      var isFreeGiftRequest = !!(event && event.detail && event.detail.source === 'freegift');
      setViewCartButtonLoading(isActive);
      setGlobalPendingState(isActive);

      if (!isActive) {
        scheduleOptimisticRowClear(50);
        // After external cart requests finish, re-sync to ensure free gift state is correct.
        // Freegift's own requests already fetch the updated cart and refresh the UI.
        if (!isFreeGiftRequest) {
          scheduleSync('cart-request-end', 80);
        }
      }
    });

    document.addEventListener('theme.cart.drawer.loaded', function () {
      setTimeout(function () {
        applyVisualState(lastCartState);
        animateDrawerTransition();
        setGlobalPendingState(false);
        scheduleOptimisticRowClear(0);
      }, 0);

      if (!syncInFlight && !internalThemeRefreshActive) {
        // Re-sync after external drawer reloads to ensure gifts are correctly added/removed.
        scheduleSync('drawer-loaded', 80);
      }
    });

    document.addEventListener('cart-update', function (event) {
      if (event && event.detail && event.detail.items) {
        lastCartState = getCartState(event.detail);
      }

      setTimeout(function () {
        applyVisualState(lastCartState);
        animateDrawerTransition();
        setGlobalPendingState(false);
        scheduleOptimisticRowClear(0);
      }, 0);

      if (!syncInFlight && !internalThemeRefreshActive) {
        // Trigger a fresh sync to add/remove free gift items if needed.
        // This catches cases where the user updates qty/removes items via theme buttons,
        // and the freegift state needs to mutate (add/remove the gift line).
        scheduleSync('cart-update', 80);
      }
    });

    document.addEventListener('click', function (event) {
      var removeControl = event.target && event.target.closest ? event.target.closest('[data-cart-remove]') : null;
      if (removeControl) {
        setOptimisticRowState(removeControl, 'remove', 0);
        return;
      }

      var quantityButton = event.target && event.target.closest ? event.target.closest('cart-update-quantity .btn-quantity') : null;
      if (!quantityButton) return;

      var quantityRoot = quantityButton.closest('cart-update-quantity');
      if (!quantityRoot) return;

      var quantityControl = quantityRoot.querySelector('[data-cart-quantity]');
      if (!quantityControl) return;

      setOptimisticRowState(quantityControl, 'update');

      requestAnimationFrame(function () {
        var nextQuantity = Number(quantityControl.value);
        setOptimisticRowState(quantityControl, 'update', Number.isFinite(nextQuantity) ? nextQuantity : undefined);
      });
    }, true);

    document.addEventListener('change', function (event) {
      var quantityControl = event.target && event.target.closest ? event.target.closest('[data-cart-quantity]') : null;
      if (!quantityControl) return;
      var nextQuantity = Number(quantityControl.value);
      setOptimisticRowState(quantityControl, 'update', Number.isFinite(nextQuantity) ? nextQuantity : undefined);
    }, true);

    var allowCheckoutPassthrough = false;

    function ensureGiftsCorrectThenCheckout(checkoutButton) {
      // Force a fresh fetch + mutation cycle, then re-trigger the click
      fetchCart()
        .then(function (cart) {
          var state = getCartState(cart);
          var queue = buildMutationQueue(state);
          if (!queue.length) return cart;
          return runMutationQueue(queue).then(fetchCart);
        })
        .then(function (cart) {
          var state = getCartState(cart);
          applyVisualState(state);

          if (state.items.length > 0 && state.paidLineCount === 0) {
            return;
          }

          allowCheckoutPassthrough = true;
          try {
            checkoutButton.click();
          } finally {
            setTimeout(function () { allowCheckoutPassthrough = false; }, 100);
          }
        })
        .catch(function (err) {
          console.error('Free gift checkout sync failed', err);
          queueSync('checkout-sync-failed');
        });
    }

    document.addEventListener('click', function (event) {
      var checkoutButton = event.target.closest('.button-checkout, [name="checkout"], #cart-checkout, #cart-sidebar-checkout');

      if (checkoutButton && !allowCheckoutPassthrough) {
        event.preventDefault();
        event.stopImmediatePropagation();
        ensureGiftsCorrectThenCheckout(checkoutButton);
        return;
      }

      var blockedButton = event.target.closest('[data-fg-blocked="true"]');
      if (!blockedButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      queueSync('blocked-checkout');
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !(form instanceof HTMLFormElement)) return;

      var checkoutButton = form.querySelector('[data-fg-blocked="true"]');
      if (!checkoutButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      queueSync('blocked-submit');
    }, true);
  }

  bindCartMutationHooks();
  bindThemeHooks();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      queueSync('dom-ready');
      setTimeout(animateDrawerTransition, 0);
    });
  } else {
    queueSync('initial');
    setTimeout(animateDrawerTransition, 0);
  }
})();
